import { render } from "./NumbersBlock.vue?vue&type=template&id=064424a6&scoped=true"
import script from "./NumbersBlock.vue?vue&type=script&lang=js"
export * from "./NumbersBlock.vue?vue&type=script&lang=js"

import "./NumbersBlock.vue?vue&type=style&index=0&id=064424a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064424a6"]])

export default __exports__